<div
  #container
  class="cm-splitter cm-component"
  [ngClass]="layout === 'horizontal' ? 'cm-splitter-horizontal' : 'cm-splitter-vertical'"
  [class]="styleClass"
  [ngStyle]="style"
>
  @for (panel of panels; track $index; let i = $index) {
    <div
      class="cm-splitter-panel"
      [class]="panelStyleClass"
      [ngStyle]="panelStyle"
      [ngClass]="{ 'cm-splitter-gutter-animation': gutterAnimation }"
    >
      <ng-container *ngTemplateOutlet="panel"></ng-container>
    </div>
    @if (i !== panels?.length - 1) {
      <div class="cm-splitter-gutter" [ngClass]="layout">
        <!-- Split panel type 1 -->
        @if (panelType === 1) {
          <div class="cm-splitter-gutter-handle p-gutter-section" [ngClass]="layout">
            <div class="cm-splitter-icon vertical-button">
              <button
                mat-icon-button
                class="splitter-button"
                type="button"
                (click)="updatePanelSize(-2)"
                [disabled]="gridCollapsed$ | async"
              >
                <span
                  class="r1-icon r1-icon-double-chevron"
                  [ngClass]="layout === 'horizontal' ? 'r1-icon-chevron-left-light' : 'r1-icon-chevron-up-light'"
                  size="lg"
                ></span>
              </button>
            </div>
            <div class="cm-splitter-icon vertical-button">
              <button
                mat-icon-button
                class="splitter-button"
                type="button"
                (click)="updatePanelSize(-1)"
                [disabled]="gridCollapsed$ | async"
              >
                <span
                  class="r1-icon r1-icon-single-chevron"
                  [ngClass]="layout === 'horizontal' ? 'r1-icon-angle-left-light' : 'r1-icon-angle-up-light'"
                  size="lg"
                ></span>
              </button>
            </div>
            <div class="p-gutter-splitter-label" [ngClass]="layout">
              {{ splitterLabel }}
            </div>
            <div class="cm-splitter-icon vertical-button">
              <button
                mat-icon-button
                class="splitter-button"
                type="button"
                (click)="updatePanelSize(1)"
                [disabled]="gridFullWidth$ | async"
              >
                <span
                  class="r1-icon r1-icon-single-chevron"
                  [ngClass]="layout === 'horizontal' ? 'r1-icon-angle-right-light' : 'r1-icon-angle-down-light'"
                  size="lg"
                ></span>
              </button>
            </div>
            <div class="cm-splitter-icon vertical-button">
              <button
                mat-icon-button
                class="splitter-button"
                type="button"
                (click)="updatePanelSize(2)"
                [disabled]="gridFullWidth$ | async"
              >
                <span
                  class="r1-icon r1-icon-double-chevron"
                  [ngClass]="layout === 'horizontal' ? 'r1-icon-chevron-right-light' : 'r1-icon-chevron-down-light'"
                  size="lg"
                ></span>
              </button>
            </div>
          </div>
        }

        <!-- Split panel type 2 -->
        @if (panelType === 2) {
          <div class="cm-splitter-gutter-handle p-gutter-section" [ngClass]="layout">
            @if (layout === 'vertical') {
              <div class="p-gutter-splitter-label vertical">
                {{ splitterLabel }}
              </div>
            }

            @if ((gridCollapsed$ | async) === false) {
              <div class="cm-splitter-icon vertical-button">
                <button
                  mat-icon-button
                  class="splitter-button"
                  type="button"
                  (click)="updatePanelSize(-2)"
                  [disabled]="gridCollapsed$ | async"
                >
                  <span
                    class="r1-icon r1-icon-double-chevron"
                    [ngClass]="layout === 'horizontal' ? 'r1-icon-chevron-left-light' : 'r1-icon-chevron-up-light'"
                    size="lg"
                  ></span>
                </button>
              </div>
            }
            @if (gridCollapsed$ | async) {
              <div class="cm-splitter-icon vertical-button">
                <button
                  mat-icon-button
                  class="splitter-button"
                  type="button"
                  (click)="updatePanelSize(2)"
                  [disabled]="gridFullWidth$ | async"
                >
                  <span
                    class="r1-icon r1-icon-double-chevron"
                    [ngClass]="layout === 'horizontal' ? 'r1-icon-chevron-right-light' : 'r1-icon-chevron-down-light'"
                    size="lg"
                  ></span>
                </button>
              </div>
            }
            @if ((gridFullWidth$ | async) && enableHalfSplit) {
              <div class="cm-splitter-icon vertical-button">
                <button
                  mat-icon-button
                  class="splitter-button"
                  type="button"
                  (click)="updatePanelSize(-1)"
                  [disabled]="gridCollapsed$ | async"
                >
                  <span
                    class="r1-icon r1-icon-single-chevron"
                    [ngClass]="layout === 'horizontal' ? 'r1-icon-angle-left-light' : 'r1-icon-angle-up-light'"
                    size="lg"
                  ></span>
                </button>
              </div>
            }
            @if ((gridFullWidth$ | async) === false && enableHalfSplit) {
              <div class="cm-splitter-icon vertical-button">
                <button
                  mat-icon-button
                  class="splitter-button"
                  type="button"
                  (click)="updatePanelSize(1)"
                  [disabled]="gridFullWidth$ | async"
                >
                  <span
                    class="r1-icon r1-icon-single-chevron"
                    [ngClass]="layout === 'horizontal' ? 'r1-icon-angle-right-light' : 'r1-icon-angle-down-light'"
                    size="lg"
                  ></span>
                </button>
              </div>
            }
            @if (layout === 'horizontal') {
              <div class="p-gutter-splitter-label horizontal">
                {{ splitterLabel }}
              </div>
            }
          </div>
        }
      </div>
    }
  }
</div>
